import { render, staticRenderFns } from "./TabDocFirmado.vue?vue&type=template&id=3d92a657&scoped=true"
import script from "./TabDocFirmado.vue?vue&type=script&lang=js"
export * from "./TabDocFirmado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d92a657",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d92a657')) {
      api.createRecord('3d92a657', component.options)
    } else {
      api.reload('3d92a657', component.options)
    }
    module.hot.accept("./TabDocFirmado.vue?vue&type=template&id=3d92a657&scoped=true", function () {
      api.rerender('3d92a657', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabDocFirmado.vue"
export default component.exports